import React from 'react';

import {CircularProgress, Modal, ModalClose, ModalDialog, Stack} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";


class MessageImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            content: null,
            modalOpen: false,
        }
    }

    async componentDidMount() {
        await this.retrieveContent()
    }

    async retrieveContent(){
        const url = `message/${this.props.message.id}/download`;
        const api = new BaseApi();
        let params = {};
        let response = await api.get(
            url,
            params
        );
        this.setState({
            content: response.data.content
        })
    }

    render() {
        if (!this.state.content) {
            return (
                <CircularProgress/>
            )
        }
        return (
            <Stack>
                <img
                    src={`data:image/${this.props.message.extension};base64,${this.state.content}`}
                    loading="lazy"
                    alt={this.props.message.uploadname}
                    style={{
                        maxWidth: '275px',
                        borderRadius: '16px',
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        this.setState({
                            modalOpen: true,
                        })
                    }}
                />
                {
                    !this.props.hideModal?
                        <Modal
                            open={this.state.modalOpen}
                        >
                            <ModalDialog
                                layout={'center'}
                                size="sm"
                            >
                                <ModalClose
                                    onClick={() => {
                                        this.setState({
                                            modalOpen: false,
                                        })
                                    }}
                                />
                                <img
                                    src={`data:image/${this.props.extension};base64,${this.state.content}`}
                                    loading="lazy"
                                    alt={this.props.message.uploadname}
                                    style={{
                                        maxHeight: 'calc(80vh)',
                                    }}
                                />
                            </ModalDialog>
                        </Modal>:
                        null
                }
            </Stack>
        )
    }
}

export default MessageImage
